<template>
  <div>
    <Form :title="`Alterar ${title}`" :type="id" :types="types" :fields="fields" @submit="submit" />
  </div>
</template>

<script>
import Form from './components/Form'
import { getDictionaryTypes, getDictionaryFields, updateDictionary } from '@/services/configurations'

export default {
  name: 'ConfigurationsHome',
  components: {
    Form
  },
  data: () => ({
    title: '',
    id: '',
    fields: [],
    types: []
  }),
  created() {
    const { id } = this.$route.params
    this.id = id
    this.title = id === 'entities' ? 'Dados' : 'Ações'
  },
  mounted() {
    const { id } = this
    this.fetch(getDictionaryTypes, 'types', { id })
    this.fetch(getDictionaryFields, 'fields', { id })
  },
  methods: {
    async submit(payload) {
      try {
        const { id } = this
        await updateDictionary(id, payload)
        this.$router.push('/configurations')
        this.$buefy.toast.open({
          duration: 5000,
          message: 'Configuração atualizada com sucesso!',
          type: 'is-success'
        })
      } catch (error) {
        this.$buefy.toast.open({
          duration: 5000,
          message: 'Falha ao atualizar configuração!',
          type: 'is-danger'
        })
      }
    },
    async fetch (handler, field, params) {
      const data = await handler(params)
      this[field] = data
    },
  }
};
</script>

<style>
</style>
